export default "__VITE_ASSET__Cm2DjI0q__"